import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full py-12 px-4 md:px-8 max-w-4xl mx-auto" data-id="element-71">
      <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-72">
        <motion.div className="flex-1 space-y-6" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-73">
          <h1 className="font-handwritten text-4xl md:text-5xl lg:text-6xl text-forest-green leading-tight font-bold" data-id="element-74">
            Oskar hatte einen Darmverschluss – die Nachsorge hat alles verändert
          </h1>
          <p className="text-lg md:text-xl text-warm-brown/90 leading-relaxed font-serif" data-id="element-75">
            Wie wir nach dem Schock geholfen haben, Oskars Darm wieder
            aufzubauen – natürlich und sanft.
          </p>
        </motion.div>

        <motion.div className="flex-1 w-full" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-76">
          <div className="relative rounded-2xl overflow-hidden shadow-diary border-4 border-off-white rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-77">
            <img src="https://images.unsplash.com/photo-1544568100-847a948585b9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Oskar der Hund ruht sich aus" className="w-full h-[300px] md:h-[400px] object-cover" data-id="element-78" />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4" data-id="element-79">
              <p className="text-white font-handwritten text-2xl" data-id="element-80">
                Oskar auf dem Weg der Besserung 🐾
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}